/**
 * Utility helpers for dealing with display names / initials.
 */
export function getInitials(name: string) {
  const parts = name.trim().split(/\s+/);
  if (parts.length === 0) {
    return '';
  }
  if (parts.length === 1) {
    return parts[0].charAt(0).toUpperCase();
  }
  return `${parts[0].charAt(0)}${parts[parts.length - 1].charAt(0)}`.toUpperCase();
}

export function getDisplayName(
  fullName: string | null | undefined,
  fallback: string
) {
  if (fullName && fullName.trim().length > 0) {
    return fullName;
  }
  return fallback;
}


